import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { money, toBase } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const CURRENCIES = ["USD", "INR", "EUR", "GBP", "AED", "AUD", "CAD", "SGD", "JPY"];

/**
 * Number input + currency select, with a live muted base-currency equivalent line beneath.
 * value: number|""  currency: string  onChangeValue(n)  onChangeCurrency(code)
 */
export function CurrencyInput({ value, currency = "USD", onChangeValue, onChangeCurrency, testid }) {
  const { data: rates } = useQuery({ queryKey: ["exchange-rates"], queryFn: () => get("/crm/exchange-rates") });
  const base = rates?.base || "USD";
  const equivalent = value ? toBase(Number(value), currency, rates) : null;
  const showEquivalent = equivalent != null && currency !== base;

  return (
    <div>
      <div className="flex gap-2">
        <Input type="number" data-testid={testid} value={value ?? ""} className="flex-1"
          onChange={(e) => onChangeValue(e.target.value === "" ? "" : Number(e.target.value))} />
        <Select value={currency} onValueChange={onChangeCurrency}>
          <SelectTrigger className="w-24" data-testid={testid ? `${testid}-currency` : undefined}><SelectValue /></SelectTrigger>
          <SelectContent>{CURRENCIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {showEquivalent && (
        <div className="mt-1 text-xs text-muted-foreground">
          {money(Number(value), currency)} ≈ {money(equivalent, base)}
        </div>
      )}
    </div>
  );
}
